import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlightMatches' })
export class HighlightMatchesPipe implements PipeTransform {
   transform(value: string): string {
      if (!value) return '';

      return value
         .replace(
            /([A-HJ-NPR-Z0-9]{17}|[A-Z]{2,3}[\s-]?\d{3,5}[\s-]?[A-Z0-9]{0,3})/gi,
            '<mark>$&</mark>'
         );
   }
}